/* eslint-disable no-unused-vars */
let socket = null;

const listeners = new Set();

function connect(url = process.env.VUE_APP_MPAY_WS) {
  if (socket && socket.readyState <= 1) {
    return socket;
  }

  socket = new WebSocket(url);

  socket.onopen = () => {
    // console.log("[WS] Connected");
  };

  socket.onmessage = event => {
    let message;
    try {
      message = JSON.parse(event.data);
    } catch (e) {
      // console.error("[WS] Invalid JSON:", event.data);
      return;
    }

    listeners.forEach(cb => cb(message));
  };

  socket.onerror = error => {
    // console.error("[WS] Error:", error);
  };

  socket.onclose = () => {
    // console.log("[WS] Disconnected");
  };

  return socket;
}

function disconnect() {
  if (socket) {
    socket.close();
    socket = null;
  }
}

function addMessageListener(callback) {
  listeners.add(callback);
}

function removeMessageListener(callback) {
  listeners.delete(callback);
}

export default {
  connect,
  disconnect,
  addMessageListener,
  removeMessageListener
};

/* VUE usage
  ....
  ....
  methods: {
    handleWSMessage(message) {
      // code
    }
  },
  mounted() {
    wsService.connect();
    wsService.addMessageListener(this.handleWSMessage);
  },
  beforeDestroy() {
    wsService.removeMessageListener(this.handleWSMessage);
    wsService.disconnect(); // optional: only call if you're the last component using it
  }
  ....
  ....
*/
